import { BoxProps, ColorOptions, TextProps } from '@jfs/ui-new'
import { TextStyle, ViewStyle } from 'react-native'

export const styles1 = (breakpoint: number) => {
  const isMobile = breakpoint < 640
  return {
    container: {
      flexDirection: 'column',
      overflowY: isMobile ? 'auto' : 'hidden',
    } as BoxProps,

    titleContainer: { pl: 16 } as BoxProps,

    header: { alignItems: 'center', marginVertical: 10 } as TextStyle,

    formActionView: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'center',
      zIndex: -1,
      paddingTop: 8,
    } as ViewStyle,
    // Todo
    cellUnderlayColor: '#F8F8F8',
    cellContainer: {
      enabled: {
        flexDirection: 'row',
        padding: 8,
        pl: 16,
      } as BoxProps,
      disabled: {
        flexDirection: 'row',
        padding: 8,
        pl: 16,
        cursor: 'not-allowed',
        marginTop: -2,
      } as BoxProps,
    },
    cellText: { flex: 1, height: 25 } as TextStyle,
    // cellStatusView: { flex: 1, flexDirection: 'row' } as ViewStyle,
    cellStatusText: { height: 25 } as TextStyle,
    cellStatusView: {
      Active: {
        width: 50,
        padding: 2,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 1,
        backgroundColor: 'GREEN',
      } as BoxProps,
      Inactive: {
        width: 62,
        padding: 2,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 1,
        // Todo
        backgroundColor: '#888888' as ColorOptions,
      } as BoxProps,
      Blocked: {
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 1,
        width: 60,
        padding: 2,
        // Todo
        backgroundColor: '#CA4848' as ColorOptions,
      } as BoxProps,
      Suspend: {
        padding: 2,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 1,
        width: 60,
        // Todo
        backgroundColor: '#CC7F00' as ColorOptions,
      } as BoxProps,
      'Hot Merchant': {
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 1,
        minWidth: 60,
        maxWidth: 105,
        padding: 2,
        backgroundColor: 'GREEN',
      } as BoxProps,
      'Closed By Merchant': {
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 1,
        minWidth: 60,
        padding: 2,
        maxWidth: 145,
        // Todo
        backgroundColor: '#888888' as ColorOptions,
      } as BoxProps,
      'Closed By Ops Team': {
        minWidth: 60,
        padding: 2,
        maxWidth: 135,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 1,
        // Todo
        backgroundColor: '#888888' as ColorOptions,
      } as BoxProps,
    },
    cellStatusValue: {
      color: 'WHITE',
      textTransform: 'uppercase',
      letterSpacing: 0.6,
      fontSize: 10,
      fontWeight: 'bold',
    } as TextProps,
    cellRadioButton: {
      marginHorizontal: 8,
      justifyContent: 'center',
    } as ViewStyle,
    flatList: (height: any) =>
      ({
        height: height,
        overflow: 'auto',
        overflowX: 'hidden',
      } as ViewStyle),
    seperator: {
      height: 2,
    } as BoxProps,
    hoverState: {
      // Todo
      backgroundColor: '#F0F0F0',
    } as ViewStyle,
  }
}
